/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Title_RequiredInputs */

const en_editor_title_required = /** @type {(inputs: Editor_Title_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give the recipe a title.`)
};

const de_editor_title_required = /** @type {(inputs: Editor_Title_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib dem Rezept einen Titel.`)
};

/**
* | output |
* | --- |
* | "Give the recipe a title." |
*
* @param {Editor_Title_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_title_required = /** @type {((inputs?: Editor_Title_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Title_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_title_required(inputs)
	return en_editor_title_required(inputs)
});